<template>
    <template v-if="typeof template === 'object'">
        <component :is="componentMap[template.name] || template.name" v-bind="template.props">
            <template v-if="template.children?.length">
                <template v-for="item in template.children" :key="item.modelKey">
                    <RenderFragment :template="item" />
                </template>
            </template>
        </component>
    </template>
    <template v-else>
        {{ template }}
    </template>
</template>

<script setup lang="ts">
import HomeHeader from '@/components/header/home-header.vue';
import BlockContainer from './block-container.vue';
import XichengBanner from '@/views/home/part/banner/index.vue';
import CommonTitleTemplate from './common-title-template.vue';
import CardListTemplate from './card-list-template/index.vue';
import NewsNoticeCard from '../module/news-notice-card.vue';
import CommonFooter from './common-footer.vue';
import CommonHeaderMenu from './common-header-menu.vue';
import ProjectList from './project-list.vue';
import HomeBanner from './home-banner.vue';

const componentMap = {
    HomeHeader,
    BlockContainer,
    XichengBanner,
    CommonTitleTemplate,
    NewsNoticeCard,
    CardListTemplate,
    CommonFooter,
    CommonHeaderMenu,
    ProjectList,
    HomeBanner,
};

const props = defineProps({
    template: {
        type: [Object, String, Number, Boolean],
        default: () => {
            return {};
        },
    },
});
</script>
